<template>
	<div style="height: 550px; overflow-y:scroll; width: 100%;">
		<el-tree class="filter-tree" :props="defaultProps" lazy :load="loadNode" :filter-node-method="filterNode"
			ref="tree" :highlight-current="true" :accordion="accordion" @node-click="nodeSelection">
			<div slot-scope="{ node, data }">
				<div style="display: inline-block; width: 100%;">
					<el-divider content-position="left">{{data.organize_name}}</el-divider>
					<el-checkbox-group v-model="post_ids" @change="handleCheckboxChangeGroup(data.projectPostList)">
						<el-row style="width: 100%; margin-top: 10px;">
							<el-col :span="6" v-for="post in data.projectPostList" :key="post.id"
								style="margin-bottom: 5px;">
								<el-checkbox :label="post.post_id">
									{{post.post_name}}
								</el-checkbox>
							</el-col>
						</el-row>
					</el-checkbox-group>
					<hr />
				</div>
			</div>
		</el-tree>
	</div>
</template>

<script>
	export default {
		props: ["accordion", 'post_ids_prop'],
		data() {
			return {
				post_ids: [],
				organize_id: "",
				organize_name: "",
			}
		},
		methods: {
			//懒加载
			async loadNode(node, resolve) {
				if (node.level === 0) {
					return resolve(await this.Find('', 'group'));
				} else {
					resolve(await this.Find(node.data.id, ''));
				}
			},
			//查询组织架构
			async Find(e, spare8) {
				var url = "organize/selectOrganizePost";
				var record = {
					organize_id: e == undefined ? '' : e,
					spare8: spare8 == undefined ? '' : spare8
				};
				var result = [];
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						result = data;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}
				return result;
			},
			//选择节点
			nodeSelection(data, node) {
				this.organize_id = data.id;
				this.organize_name = data.organize_name;
			},
			//点击多选框组
			handleCheckboxChangeGroup(postList) {
				if (this.$props["accordion"]) {
					var post_ids = [];
					postList.forEach(item => {
						if (this.post_ids.indexOf(item.id) != -1) {
							post_ids.push(item.id);
						}
					})
					this.post_ids = post_ids;
				}
				this.commit();
			},
			//确定
			commit() {
				var object = {
					post_ids: this.post_ids,
					organize_id: this.organize_id,
					organize_name: this.organize_name,
				}
				this.$emit("commit", object);
			}
		},
		watch: {
			post_ids_prop(newValue) {
				this.post_ids = newValue;
			}
		},
		created() {}
	}
</script>

<style scoped="scoped">
	>>>.el-divider__text {
		font-size: 17px !important;
		font-weight: bold;
	}
	
	>>>.el-tree-node__content>div {
		width: 100%;
	}
	
	>>>.el-tree-node__content {
		height: 100%;
		width: 100%;
		margin-bottom: 20px;
	}
	
	>>>.el-tree-node__content>.el-tree-node__expand-icon {
		font-size: 15px;
	}
</style>



// WEBPACK FOOTER //
// SetPost.vue?7501c86c